module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/metaverse-9d154bd1021db45973a2a22977dcf50d.png";